import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class UtilsService {
  //eslint-disable-next-line
  constructor() {}

  public compareVersion(version1: string, version2: string): boolean {
    const levels1 = version1.split('.');
    const levels2 = version2.split('.');

    const length = Math.max(levels1.length, levels2.length);

    for (let i = 0; i < length; i++) {
      const v1 = i < levels1.length ? parseInt(levels1[i]) : 0;
      const v2 = i < levels2.length ? parseInt(levels2[i]) : 0;
      if (v1 > v2) {
        return true;
      }
      if (v1 < v2) {
        return false;
      }
    }

    return false;
  }
}
